import { Outlet, createRootRouteWithContext, redirect } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import type { AuthContextValue } from '@/lib/auth';

interface RouterContext {
  queryClient: QueryClient;
  auth: AuthContextValue;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  beforeLoad: ({ context, location }) => {
    if (context.auth?.loading) return;
    if (!context.auth?.isAuthenticated && location.pathname !== '/login') {
      throw redirect({ to: '/login', search: { next: location.pathname } });
    }
  },
});

function RootComponent() {
  return <Outlet />;
}
